module.exports = __webpack_public_path__ + "static/media/qb_sign_in_button_med.e7b1ad8b.svg";